import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AdminresetPassword,
  FORGET_PASSWORD,
  ForgetPassword,
  GET_USER,
  GetUser,
  HttpRequest,
  JoinByLink,
  LOGIN_USER,
  LoginApi,
  LOGOUT_USER,
  REGISTER_USER,
  RESEND_OTP,
  RESET_PASSWORD,
  RegisterApi,
  RequestMethod,
  ResendOtp,
  ResetPassword,
  SEND_OTP,
  SendOtp,
  VERIFY_OTP,
  VerifyOtp,
  HttpClient,
  SendOneTimePasswordApi
} from '@/api';

import {
  SignInRequest,
  SignInResponse,
  SignUpRequest,
  SignUpResponse,
  SendOneTimePasswordRequest,
  SendOneTimePasswordResponse,
  VerifyOneTimePasswordRequest,
  VerifyOneTimePasswordResponse
} from '@/@types/openapi-imports';

import { HttpApiResponse, HttpRejectResponse } from '@/api/interfaces';

interface HttpResponse<T> {
  status: number;
  result: T;
  message: string;
  token: string;
  success: boolean;
  notVerified: boolean;
  blocked: boolean;
  authMethod: string;
  profileImage: string;
  userId?: string;
}

// Define the payload type for reset password
interface ResetPasswordPayload {
  email: string | null;
  newPassword: string;
  confirmPassword: string;
}
/*
export const LoginUser:any = createAsyncThunk(LOGIN_USER, async (payload: any) => {

  try {
    const response = (await HttpRequest({
      url: Login,
      method: RequestMethod.POST,
      body: payload,
    })) as HttpResponse<any>;

    const accessToken = response?.token;

    if (accessToken) {
      document.cookie = `accessToken=${accessToken}; path=/; Secure; SameSite=Strict;`;
    }

    return response;
  } catch (error) {
    throw error;
  }
});
*/

export const LoginUser = createAsyncThunk<
  HttpApiResponse<SignInResponse>, // success return shape
  SignInRequest, // input arg
  HttpRejectResponse
>(LOGIN_USER, async (payload, thunkAPI) => {
  try {
    const response = await HttpClient<SignInResponse>({
      method: 'POST',
      url: LoginApi,
      data: payload
    });
    const accessToken = response.data.accessToken;

    if (accessToken) {
      document.cookie = `accessToken=${accessToken}; path=/; Secure; SameSite=Strict;`;
    }
    console.log('Login Response ', response);
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message,
      status: error.response?.status
    });
  }
});

export const GetUserDeatil: any = createAsyncThunk(GET_USER, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: GetUser,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error: any) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});

export const RegisterUser = createAsyncThunk<
  HttpApiResponse<SignUpResponse>, // success return shape
  SignUpRequest, // input arg
  HttpRejectResponse
>(REGISTER_USER, async (payload, thunkAPI) => {
  try {
    const response = await HttpClient<SignUpResponse>({
      method: 'POST',
      url: RegisterApi,
      data: payload
    });
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message,
      status: error.response?.status
    });
  }
});

export const VerifyOneTimePassword = createAsyncThunk<
  HttpApiResponse<VerifyOneTimePasswordResponse>, // success return shape
  VerifyOneTimePasswordRequest, // input arg
  HttpRejectResponse
>(VERIFY_OTP, async (payload, thunkAPI) => {
  try {
    const response = await HttpClient<VerifyOneTimePasswordResponse>({
      method: 'POST',
      url: VerifyOtp,
      data: payload
    });
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message,
      status: error.response?.status
    });
  }
});

export const SendOneTimePassword = createAsyncThunk<
  HttpApiResponse<SendOneTimePasswordResponse>, // success return shape
  SendOneTimePasswordRequest, // input arg
  HttpRejectResponse
>(SEND_OTP, async (payload, thunkAPI) => {
  try {
    const response = await HttpClient<SendOneTimePasswordResponse>({
      method: 'POST',
      url: SendOneTimePasswordApi,
      data: payload
    });
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      message: error.message,
      status: error.response?.status
    });
  }
});

// Create the async thunk for resend OTP
export const resendOtp = createAsyncThunk(RESEND_OTP, async (payload: { email: string }) => {
  try {
    const response = (await HttpRequest({
      url: ResendOtp,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;
    return response;
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});
export const sendOtp = createAsyncThunk(SEND_OTP, async (payload: { email: string }) => {
  try {
    const response = (await HttpRequest({
      url: SendOtp,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;
    return response;
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});

export const forgetPassword = createAsyncThunk(FORGET_PASSWORD, async (payload: { email: string }) => {
  try {
    const response = (await HttpRequest({
      url: ForgetPassword,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;
    return response;
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});

export const resetPassword = createAsyncThunk(RESET_PASSWORD, async (payload: any) => {
  try {
    const response = (await HttpRequest({
      url: ResetPassword,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});

export const adminresetPassword: any = createAsyncThunk(RESET_PASSWORD, async (payload: ResetPasswordPayload) => {
  try {
    const response = (await HttpRequest({
      url: AdminresetPassword,
      method: RequestMethod.POST,
      body: payload
    })) as HttpResponse<any>;

    return response;
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: TODO: handle error
    throw error;
  }
});

export const LogoutUser: any = createAsyncThunk(LOGOUT_USER, async () => {
  document.cookie = 'accessToken=; path=/; expires=0;';
  document.cookie?.split(';').forEach(c => {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
  Promise.resolve();
});
